import Vue from 'vue'
import Router from 'vue-router'
import ParamSwitch from '@/components/ParamSwitch'
import Demo from '@/components/Demo'
import VRDemo from '@/components/VRDemo'
import Source from '@/components/Source'
import Vipo from '@/components/Vipo'
import VipoCollection from '@/components/VipoCollection'
import BobyConnect from '@/components/BobyConnect'
import VideoService from '@/components/VideoService'
import CMP from '@/components/CMP'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ParamSwitch',
      component: ParamSwitch,
      props: true
    },

    {
      path: '/demo',
      name: 'Demo Player',
      component: Demo,
      props: true
    },

    {
        path: '/source',
        name: 'Source Player',
        component: Source,
        props: true
    },

    {
      path: '/vr',
      name: 'VR 360° Demo Player',
      component: VRDemo
    },

    {
        path: '/vipo/bonr/:boNr',
        name: 'Vipo BoNr Player',
        component: Vipo,
        props: true
    },

    // {
    //   path: '/vipo/:collectionId/:videoId',
    //   name: 'Vipo Player',
    //   component: Vipo,
    //   props: true
    // },
    //
    // {
    //   path: '/vico/:collectionId/:videoId?',
    //   name: 'Vipo Collection Player',
    //   component: VipoCollection,
    //   props: true
    // },


    {
      path: '/vipo/:playlistId/:videoVipoId?',
      name: 'Vipo Player',
      component: VideoService,
      props: true
    },


    {
      path: '/cbin-legacy/:videoCbinId',
      name: 'BobyConnect Player',
      component: BobyConnect,
      props: true
    },

    {
      path: '/cbin/:videoCbinId',
      name: 'VideoService Player',
      component: VideoService,
      props: true
    },

    {
      path: '/vs/playlist/:playlistId/:videoCbinId?',
      name: 'VideoService Playlist Player',
      component: VideoService,
      props: true
    },

    {
      path: '/vs/:videoCbinId',
      name: 'VideoService Player',
      component: VideoService,
      props: true
    },

    {
      path: '/cmp/:videoKey',
      name: 'CMP Player',
      component: CMP,
      props: true
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js